import { GetColumnLiteralSearchProps } from './functions.jsx';

/**
 * Columnas comunes para modems
 * @param {Object} lang objeto de traduccion inyectado por withLocale
 * @param {Array} typeFilter [{text, value}] para el filtro de la columna Tipo
 */
export function getModemBaseColumns(lang, typeFilter) {
  return [
    {
      title: "IMEI",
      dataIndex: "imei",
      ...GetColumnLiteralSearchProps("imei", lang),
    },
    {
      title: lang.handle('Tipo'),
      dataIndex: "modem_type_code",
      filters: typeFilter,
      onFilter: (value, record) => record.modem_type_uuid === value,
      sorter: (a, b) => (a.modem_type_code || '').localeCompare(b.modem_type_code || ''),
    },
    {
      title: lang.handle('Número de serie'),
      dataIndex: "serial_number",
      ...GetColumnLiteralSearchProps("serial_number", lang),
    },
    {
      title: "MAC",
      dataIndex: "mac",
      ...GetColumnLiteralSearchProps("mac", lang),
    },
  ];
}
